<template>
  <div class="add headFixed bodyPd hasBotBtns">
    <div class="fixed_head">
      <div class="content">
        <div class="go_back">
          <span @click="$router.back(-1)" class="goBackBtn"></span>
          <span class="titles">设备管理</span>
          <span class="right addHome" @click="addHome()">添加</span>
        </div>

      </div>
    </div>
    <!-- 住宅列表 -->
    <div class="roomWrapper">
      <div class="list list_prev list_normal">
        <p class="titleTip">请添加或修改设备名称或所在房间</p>
        <div class="item choose-item" :class="index==currentIndex?'choose-active':''"
             v-for="(data,index) in list"
             :key="index">
          <div class="r-box">
            <span class="r-con">{{ data.name }}</span>
            <span class="icon-edit" @click="editScene(index)"></span>
            <span class="icon-del" @click="delScene(index)"></span>
          </div>
        </div>
      </div>
    </div>


    <mt-popup v-model="popupVisible">
      <div class="smart-modal">
        <h1>{{ uiTitle == 1 ? "添加设备名称或房间" : "修改设备名称或房间" }}</h1>
        <input type="text" name="" id="" v-model="homeName">
        <div class="smart-modal-foot">
          <span @click="hideModal">取消</span>
          <span @click="onSubmit">确定</span>
        </div>
      </div>
    </mt-popup>
  </div>
</template>
<script>
import {Popup, Toast} from 'mint-ui';
import HeadNav from '../../headNav/headNav'

export default {
  name: 'add',
  data() {
    return {
      popupVisible: false,
      homeName: null,
      currentIndex: 0,
      roomId: null,
      list: [],
      disabled: false,
      flag: 1,
      uiTitle: 1,
    }
  },
  mounted() {
    this.getEqRoomList();
  },
  components: {
    'HeadNav': HeadNav
  },
  methods: {
    getScenId() {
      return this.$route.params.id;
    },
    getEqRoomList() {
      let sceneId = this.getScenId();
      let str = '';
      str = str + 'pageNo=1';
      str = str + '&pageSize=100';
      str = str + '&sceneId=' + sceneId;
      this.Api.eqRoomList(str, (msg) => {
        if (msg.code === 200) {
          this.list = msg.data;
          if (this.list && this.list.length > 0) {
            this.roomId = this.list[0].id;
          }
        }
      });
    },
    hideModal() {
      this.popupVisible = false;
    },
    showModal() {
      this.popupVisible = true;
      this.flag = 1;
    },
    editScene(index) {
      let list = this.list;
      this.uiTitle = 2;
      this.currentIndex = index;
      this.roomId = list[index].id;
      this.homeName = list[index].name;
      this.showModal();
    },
    addHome() {
      this.popupVisible = true;
      this.homeName = '';
      this.flag = 2;
      this.uiTitle = 1;
    },
    handleEdit() {
      let params = {};
      params.name = this.homeName;
      // params.useSceneId = this.getScenId();
      params.iotDeviceId = this.getScenId();
      params.id = this.roomId;
      this.Api.editRoom(params, (msg) => {
        if (msg.code === 200) {
          Toast('修改成功');
          this.getEqRoomList();
          this.hideModal();
        } else {
          Toast(msg.message);
        }
      })
    },
    handleAdd() {
      if (this.homeName) {
        let params = {};
        params.name = this.homeName;
        params.sceneId = this.getScenId();
        if (this.list.length >= 100) {
          this.popupVisible = false;
          Toast('设备名称最多只能添加100种');
        } else {
          this.Api.eqRoomAdd(params, () => {
            this.getEqRoomList();
            this.popupVisible = false;
            this.homeName = null;
          });

          this.popupVisible = false;
          this.homeName = null;
        }
      } else {
        this.popupVisible = false;
        Toast('请填写场景名称')
      }
    },
    onSubmit() {
      let flag = this.flag;
      if (flag == 1) {
        this.handleEdit();
      }

      if (flag == 2) {
        this.handleAdd();
      }
    },
    delScene(index) {
      let data = {
        "id": this.list[index].id
      }
      this.Api.delRoom(data, (msg) => {
        if (msg.code === 200) {
          Toast('删除成功');
          this.getEqRoomList();
        } else {
          Toast(msg.message);
        }
      })
    }
  }
}
</script>

<style scoped>
@import url('../equipment.css');

.list_normal {
  margin-top: 54px;
}

.list_prev .item {
  background-image: none;
}

.list_prev .item:last-child {
  border-bottom: none;
}

/* yh */
.r-box {
  height: 44px;
}

.r-con {
  width: 70%;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.titles {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
</style>




// WEBPACK FOOTER //
// src/components/equipment/scene/roomMange.vue